import { Injectable } from '@angular/core';
import { AngularFireAuth} from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { convertSnaps } from './db-utils';
import { User } from '../models/user';
import { BehaviorSubject, from, Observable, Subject } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PrivateProfile } from '../models/private-profile';


@Injectable({
  providedIn: 'root'
})
export class FirebaseAuthService {

  publicUser: firebase.User;
  completeRegister = false;
  loguedIn = false;
  publicUserToCreate: firebase.User;
  firebaseUrl = environment.firebaseUrl;
  privateProfile: PrivateProfile;
  displayNameObs: Observable<string>;


  constructor(private afAuth: AngularFireAuth, public router: Router, private fireStore: AngularFirestore,
              private http: HttpClient) {

  }

  register(email: string, password: string ): Promise<firebase.auth.UserCredential>{
    return this.afAuth.createUserWithEmailAndPassword(email , password);
  }

  getPublicUserByEmail(email: string): Observable<User>{

    return this.fireStore.collection('users',
        ref => ref.where('email', '==', email))
          .snapshotChanges()
          .pipe(
            map(snaps => {
              const users = convertSnaps<User>(snaps);
              return users.length === 1 ? users[0] : undefined;
            }), first()
          );
  }

  verifySponsor(sponsorEmail: string): Observable<string> {
    return this.http.get<string>(this.firebaseUrl + 'getSponsor?email=' + sponsorEmail);
  }

  async sendEmailVerification(): Promise<void>{
    await this.afAuth.currentUser.then(currentUser => {
      currentUser.sendEmailVerification();
    });
  }

  veryfyDocumentAvailable(document: string): Observable<any> {
    return this.http.get<any>(this.firebaseUrl + 'verifyDocumentAvailable?document=' + document);
  }

  veryfyDocumentAndTypeAvailable(documentType: string, document: string): Observable<any> {
    return this.http.get<any>(this.firebaseUrl + `verifyDocumentAndTypeAvailable?documentType=${documentType}&document=${document}`);
  }

  getLoguedPrivateProfileUser(userId: string): Observable<PrivateProfile>{
    return this.fireStore.collection(`users/${userId}/privateProfile`)
        .snapshotChanges()
        .pipe(
          map(snaps => {

            const privateProfile = convertSnaps<PrivateProfile>(snaps);

            return privateProfile.length === 1 ? privateProfile[0] : undefined;
          }), first()
        );
  }

  getPrivateProfileUserById(userId: string): Observable<any[]>{
    return this.fireStore.collection(`users/${userId}/privateProfile`)
            .snapshotChanges()
            .pipe(
              map(snaps => convertSnaps<any>(snaps)), first());
  }

  async loginWithGoogle(): Promise<firebase.auth.UserCredential> {
    return this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  async loginWithFacebook(): Promise<firebase.auth.UserCredential> {
    return this.afAuth.signInWithPopup(new firebase.auth.FacebookAuthProvider());
  }

  async loginWithEmail(email: string, password: string): Promise<firebase.auth.UserCredential> {
    return this.afAuth.signInWithEmailAndPassword(email, password);
  }

  async logout(): Promise<void> {
    this.afAuth.signOut().then(() => {
      console.log('sesión cerrada');
      this.publicUser = null;
      this.completeRegister = false;
      this.loguedIn = false;
      this.publicUserToCreate = null;
      this.privateProfile = null;
      this.router.navigate(['']).then(() => { window.location.reload(); });
    });
  }



  getSponsorById(sponsorId: string): Observable<User> {
    return this.fireStore.doc(`users/${sponsorId}`).get()
            .pipe(
              map(user => {
                return {
                  id: user.id,
                  ... user.data() as User
                }
              })
            );
  }


  updatePublicProfileUser(userId: string, changes: Partial<User>): Observable<any> {
    return from (this.fireStore.doc(`users/${userId}`).update(changes));
  }

  updatePrivateProfileUser(userId: string, changes: Partial<PrivateProfile>): Observable<any> {
    return from (this.fireStore.doc(`users/${userId}/privateProfile/${changes.id}`).update(changes));
  }

}
